/* ==========================================================================
   ZPK — Drawer del menu principale (§0-sexies)
   File a se', caricato con defer da layout/theme.liquid dopo zpk-theme.js.
   Come zpk-theme.js: nessuna dipendenza, tutto delegato sul document (cosi'
   regge quando il theme editor rirenderizza l'header), aggancio solo tramite
   attributi data-zpk-*.
   ========================================================================== */
(function () {
  'use strict';

  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* --- Drawer del menu principale ----------------------------------------
     Sul desktop una voce con drawer lo apre al passaggio del mouse. Da
     tastiera, e dove non c'e' hover, lo apre il bottone accanto alla voce, che
     tiene aggiornato aria-expanded. Escape chiude e riporta il fuoco sul
     bottone; uscire col fuoco dalla voce, cliccare fuori o scendere sotto i
     990px chiude.

     Il movimento (§0-sexies, §9) e' tutto nel CSS: lo script mette le classi e
     aspetta la fine delle transizioni per togliere dal layout quello che non
     si vede piu'.
     - header.is-drawer-open / .is-drawer-closing: entrata e uscita della
       cornice e dei contenuti insieme;
     - [data-zpk-drawer].is-mounted: il contenuto e' nel layout;
     - [data-zpk-drawer].is-current: e' quello di turno. Toglierla a uno e
       metterla a un altro fa la dissolvenza incrociata. */
  const OPEN_DELAY = 80;    // primo ingresso: attraversando il menu non si accende niente
  const SWITCH_DELAY = 60;  // da una voce all'altra: una passata veloce salta le voci in mezzo
  const CLOSE_DELAY = 160;  // il tempo di scendere dalla voce al drawer
  const STYLES = ['violet', 'purple', 'yellow', 'green'];
  const drawerMedia = window.matchMedia('(min-width: 990px)');

  let timer = 0;
  let current = null;   // la <li> aperta
  let warmed = false;

  const items = () => $$('[data-zpk-drawer-item]');
  const paneOf = (item) => $('[data-zpk-drawer]', item);
  const toggleOf = (item) => $('[data-zpk-drawer-toggle]', item);
  const headerOf = (el) => el.closest('[data-zpk-header]');
  const panesOf = (header) => $$('[data-zpk-drawer]', header);
  const isVisible = (header) => !!header &&
    (header.classList.contains('is-drawer-open') || header.classList.contains('is-drawer-closing'));

  // Promessa che si risolve quando finiscono le transizioni in corso su una
  // proprieta' dell'elemento. Una transizione interrotta (perche' lo stato e'
  // cambiato di nuovo) risolve lo stesso: chi aspetta ricontrolla lo stato.
  function transitionsDone(el, property) {
    const running = el.getAnimations
      ? el.getAnimations().filter((a) => a.transitionProperty === property)
      : [];
    return Promise.allSettled(running.map((a) => a.finished));
  }

  // Al primo segno di interesse per il menu si scaricano e decodificano le
  // copertine di tutti i drawer: passando da una voce all'altra sono gia'
  // pronte, e la dissolvenza non scopre riquadri grigi. Prima di allora
  // restano lazy e non pesano sul caricamento della pagina.
  function warm() {
    if (warmed) return;
    warmed = true;
    $$('[data-zpk-drawer] img').forEach((img) => {
      img.loading = 'eager';
      if (img.decode) img.decode().catch(() => {});
    });
  }

  function setExpanded(item, on) {
    item.classList.toggle('is-open', on);
    toggleOf(item)?.setAttribute('aria-expanded', String(on));
  }

  function unmount(pane) {
    pane.classList.remove('is-mounted', 'is-current');
  }

  // La cornice prende colore e altezza dei contenuti di turno. Se e' gia' a
  // schermo cambiano in transizione; se entra ora, sono subito quelli giusti.
  function syncChrome(header, pane) {
    const chrome = $('[data-zpk-drawer-chrome]', header);
    if (!chrome) return;
    const style = pane.dataset.zpkDrawerStyle;
    STYLES.forEach((name) => chrome.classList.toggle(`zpk-drawer--${name}`, name === style));
    chrome.style.setProperty('--zpk-drawer-h', `${pane.offsetHeight}px`);
  }

  function open(item) {
    const pane = paneOf(item);
    const header = headerOf(item);
    if (!pane || !header) return;
    clearTimeout(timer);
    warm();

    const visible = isVisible(header);
    current = item;
    items().forEach((other) => setExpanded(other, other === item));

    if (!pane.classList.contains('is-mounted')) {
      pane.classList.add('is-mounted');
      // Se la cornice e' gia' a schermo il contenuto nuovo parte da 0 e sfuma
      // dentro: bisogna fissarne lo stato di partenza prima di accenderlo.
      // Se entra tutto insieme, parte gia' pieno e lo porta dentro l'header.
      if (visible) getComputedStyle(pane).getPropertyValue('--zpk-pane');
    }
    pane.inert = false;
    pane.classList.add('is-current');

    panesOf(header).forEach((other) => {
      if (other === pane || !other.classList.contains('is-mounted')) return;
      other.classList.remove('is-current');
      other.inert = true;
      const token = (other.zpkLeave = (other.zpkLeave || 0) + 1);
      transitionsDone(other, '--zpk-pane').then(() => {
        if (other.zpkLeave === token && !other.classList.contains('is-current')) unmount(other);
      });
    });

    syncChrome(header, pane);
    header.zpkClose = (header.zpkClose || 0) + 1;   // un'uscita in corso non smonta piu' niente
    header.classList.remove('is-drawer-closing');
    header.classList.add('is-drawer-open');
  }

  function close({ instant = false } = {}) {
    clearTimeout(timer);
    const item = current;
    if (!item) return;
    current = null;
    items().forEach((other) => setExpanded(other, false));

    const header = headerOf(item);
    if (!header) return;
    const panes = panesOf(header).filter((pane) => pane.classList.contains('is-mounted'));
    panes.forEach((pane) => { pane.inert = true; });
    const token = (header.zpkClose = (header.zpkClose || 0) + 1);

    if (instant) {
      header.classList.remove('is-drawer-open', 'is-drawer-closing');
      panes.forEach(unmount);
      return;
    }
    header.classList.remove('is-drawer-open');
    header.classList.add('is-drawer-closing');
    transitionsDone(header, '--zpk-drawer-open').then(() => {
      if (header.zpkClose !== token || !header.classList.contains('is-drawer-closing')) return;
      header.classList.remove('is-drawer-closing');
      panesOf(header).forEach(unmount);
    });
  }

  function initDrawers() {
    if (document.body.dataset.zpkDrawerBound) return;
    document.body.dataset.zpkDrawerBound = '1';

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch' || !drawerMedia.matches) return;
      const item = event.target.closest('[data-zpk-drawer-item]');
      if (!item) return;
      warm();
      clearTimeout(timer);
      if (item === current) return;
      // Chi sta navigando da tastiera dentro un drawer non se lo vede cambiare
      // dal mouse, come gia' non se lo vede chiudere.
      if (current && $(':focus-visible', current)) return;
      timer = setTimeout(() => open(item), isVisible(headerOf(item)) ? SWITCH_DELAY : OPEN_DELAY);
    });

    document.addEventListener('pointerout', (event) => {
      if (event.pointerType === 'touch' || !drawerMedia.matches) return;
      const item = event.target.closest('[data-zpk-drawer-item]');
      if (!item) return;
      const into = event.relatedTarget;
      if (into && item.contains(into)) return;       // movimento dentro la stessa voce
      clearTimeout(timer);                             // un'apertura in attesa su questa voce decade
      if (!current) return;
      if (into && current.contains(into)) return;      // si sta rientrando nella voce aperta
      if ($(':focus-visible', current)) return;         // aperto da tastiera: resta
      timer = setTimeout(close, CLOSE_DELAY);
    });

    document.addEventListener('focusin', (event) => {
      if (event.target.closest?.('[data-zpk-drawer-item]')) warm();
    });

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-zpk-drawer-toggle]');
      if (toggle) {
        const item = toggle.closest('[data-zpk-drawer-item]');
        if (!item) return;
        if (item === current) close();
        else open(item);
        return;
      }
      if (current && !current.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !current) return;
      const item = current;
      if (item.contains(document.activeElement)) toggleOf(item)?.focus();
      close();
    });

    document.addEventListener('focusout', (event) => {
      if (!current) return;
      if (event.target.closest?.('[data-zpk-drawer-item]') !== current) return;
      if (event.relatedTarget && current.contains(event.relatedTarget)) return;
      if (current.matches(':hover')) return;   // il mouse e' ancora sopra: resta aperto
      close();
    });

    drawerMedia.addEventListener?.('change', () => { if (!drawerMedia.matches) close({ instant: true }); });

    // Theme editor: selezionare il blocco «Drawer del menu» apre il suo drawer;
    // quando la sezione viene rirenderizzata, lo stato riparte da zero.
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest?.('[data-zpk-drawer-item]');
      if (item) open(item);
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const item = event.target.closest?.('[data-zpk-drawer-item]');
      if (item && item === current) close();
    });
    document.addEventListener('shopify:section:load', () => {
      clearTimeout(timer);
      current = null;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDrawers);
  else initDrawers();
})();
